import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setErr("");
    setLoading(true);
    const res = await register(name, email, password);
    setLoading(false);
    if (!res.ok) { setErr(res.error); return; }
    nav("/portal", { replace: true });
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6">
      <div className="w-full max-w-sm bg-white border border-slate-200 rounded-lg p-8">
        <h2 className="font-display text-2xl font-semibold mb-1">Create account</h2>
        <p className="text-sm text-slate-500 mb-6">Sign up as a customer to book cleaning services.</p>
        <form onSubmit={submit} className="space-y-3" data-testid="register-form">
          <input data-testid="register-name" required placeholder="Full name"
            value={name} onChange={(e) => setName(e.target.value)}
            className="w-full px-3 py-2.5 rounded-md border border-slate-300 outline-none text-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-100"/>
          <input data-testid="register-email" type="email" required placeholder="Email"
            value={email} onChange={(e) => setEmail(e.target.value)}
            className="w-full px-3 py-2.5 rounded-md border border-slate-300 outline-none text-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-100"/>
          <input data-testid="register-password" type="password" required placeholder="Password (min 6 chars)" minLength={6}
            value={password} onChange={(e) => setPassword(e.target.value)}
            className="w-full px-3 py-2.5 rounded-md border border-slate-300 outline-none text-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-100"/>
          {err && <div className="text-sm text-red-600" data-testid="register-error">{err}</div>}
          <button type="submit" disabled={loading} data-testid="register-submit"
            className="w-full bg-slate-900 hover:bg-slate-800 disabled:opacity-60 text-white text-sm font-medium py-2.5 rounded-md transition-colors">
            {loading ? "Creating…" : "Create account"}
          </button>
        </form>
        <div className="mt-4 text-sm text-slate-500">
          Already have an account? <Link to="/login" className="text-blue-600 hover:underline">Sign in</Link>
        </div>
      </div>
    </div>
  );
}
